export const MOBILE_MAXWIDTH = '500px';
export const MOBILE_DESKTOP_THRESHOLD = 800; // App.tsx